__turbopack_context__.v({
  "muted": "_2v4w-G_muted",
  "section": "_2v4w-G_section",
});
